import { Outlet } from "@tanstack/react-router";
import { ShiftsLayout } from "layouts/ShiftsLayout";
import { TitleBar } from "./TitleBar";
import { usePageTitle } from "./utils";

export function ManageProLayout({ proId }: Readonly<{ proId: number }>) {
  const { title } = usePageTitle(proId);

  return (
    <ShiftsLayout title={`Manage Pro | ${title}`} hideDefaultHeader headerClassName="hidden">
      <TitleBar proId={proId} />
      <Outlet />
    </ShiftsLayout>
  );
}
